module.exports = __webpack_public_path__ + "static/media/arrow-blue.fdd244e3.svg";